/* eslint-disable react/prop-types, implicit-arrow-linebreak */
import React from "react";
import { Select } from "./SelectComponents";

const OccasionFilter = ({
  options,
  selectedOccasions,
  setSelectedOccasions,
}) => {
  return (
    <Select
      placeholder={I18n.t("job_board_filters.generic.occasion")}
      options={options}
      valueFunction={(occasion) => ({
        label: I18n.t(`kinds_of_moment.${occasion}`),
        value: occasion,
      })}
      selectedOptions={selectedOccasions}
      setSelectedOptions={setSelectedOccasions}
    />
  );
};

export default OccasionFilter;
